import { useState } from 'react';
import { sectionQuickLinks, topTicker } from '@/mocks/material';

function UpdateTicker() {
  const loop = [...topTicker, ...topTicker];
  return (
    <div className="bg-foreground-950 text-background-100">
      <div className="mx-auto flex max-w-[1240px] items-center gap-5 overflow-hidden px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-2 py-2 text-xs font-semibold tracking-widest text-background-100">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-70" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-400" />
          </span>
          更新条
        </span>
        <div className="flex h-9 flex-1 items-center overflow-hidden">
          <div className="ticker-track flex min-w-max items-center gap-8 whitespace-nowrap">
            {loop.map((item, idx) => (
              <span key={idx} className="flex items-center gap-2 text-xs text-background-200">
                <span className="font-medium text-secondary-300">{item.time}</span>
                <span className="text-background-300">·</span>
                <span>{item.text}</span>
                <span className="ml-6 text-foreground-500">｜</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <div className="sticky top-0 z-50">
      <UpdateTicker />
      <header className="border-b border-background-200/80 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex max-w-[1240px] items-center justify-between px-4 py-3 md:px-6">
          <a href="#top" className="flex items-center gap-2.5">
            <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
              看料网
            </span>
            <span className="rounded-sm bg-primary-500 px-1.5 py-0.5 text-[10px] font-semibold tracking-widest text-background-50">
              旧料档案
            </span>
          </a>

          <nav className="hidden items-center gap-7 md:flex">
            {sectionQuickLinks.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <button
              type="button"
              className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              按人物查档
            </button>
            <button
              type="button"
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              去翻旧账
            </button>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-800 md:hidden"
            onClick={() => setOpen((v) => !v)}
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
          </button>
        </div>

        {open && (
          <div className="border-t border-background-200/80 bg-background-50 md:hidden">
            <div className="flex flex-col gap-1 px-4 py-3 md:px-6">
              {sectionQuickLinks.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-2 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
                >
                  {item.label}
                </a>
              ))}
              <button
                type="button"
                className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50"
              >
                去翻旧账
              </button>
            </div>
          </div>
        )}
      </header>
    </div>
  );
}